module.exports = __webpack_public_path__ + "img/cloudview_music-single.82a7b853.jpg";